import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { ChevronRight, Pencil, Trash } from 'lucide-react'
import { useAuthStore } from '@/store/auth'
import { user_role } from '@/entities/user'
import { ExamLibraryProps, formatted_exam_library_profile_types } from '@/entities/exam-library'
import { useEffect, useState } from 'react'
import { useMediaQuery } from '@/hooks/use-media-query'

interface ExamLibraryListProps {
  type: string
  searchTerm?: string
  data: ExamLibraryProps[]
  onCreate?: (id: string) => void
  onDelete?: (id: string) => void
  onPreview?: (item: ExamLibraryProps) => void
}
export function ExamLibraryList({ type, searchTerm, data, onCreate, onDelete, onPreview }: ExamLibraryListProps) {
  const { user } = useAuthStore()
  const [filteredData, setFilteredData] = useState<ExamLibraryProps[]>(data?.filter(d => d.profileType == type) || [])
  const isMdAndDown = useMediaQuery('(max-width:1123px)')

  useEffect(() => {
    setFilteredData(data?.filter(d => d.profileType == type) || [])
  }, [data, type])

  return (
    <div>
      {filteredData.length > 0 ? (
        filteredData.map((item, index) => (
          <div key={index} className={cn('flex items-center justify-between p-2 rounded-lg dark:border border-slate-300 dark:border-slate-600 hover:border-pink-200 transition-colors duration-200', index % 2 == 0 ? 'bg-gray-300/40' : 'bg-gray-100/40', isMdAndDown && 'flex-col gap-y-5 py-5')}>
            <div>
              <h3 className="text-lg font-medium text-gray-900 dark:text-white">{item.title}</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">{item.description?.length > 30 ? item.description?.slice(0, 30) + '...' : item.description}</p>
            </div>
            <div className="flex gap-x-3 flex-wrap gap-y-2 justify-center">
              {(user?.role == user_role.ADMIN || user?.role == user_role.MODERATOR) && (
                <>
                  <Button variant="outline" className="flex items-center rounded-2xl p-2 hover:bg-blue-500 text-blue-500 border-blue-500 dark:text-white text-sm font-medium" onClick={() => onCreate?.(item.ref || '')}>
                    Editar
                    <Pencil className="h-4 w-4 ml-1" />
                  </Button>
                  <Button variant="outline" className="flex items-center rounded-2xl p-2 hover:bg-destructive dark:text-white text-red-500 border-red-500 text-sm font-medium" onClick={() => onDelete?.(item.ref || '')}>
                    Remover
                    <Trash className="h-4 w-4 ml-1" />
                  </Button>
                </>
              )}
              <Button className="flex items-center rounded-2xl p-2 bg-secondary/30 hover:bg-secondary/60 dark:text-white text-primary text-sm font-medium" onClick={() => onPreview?.(item)}>
                Acessar Exame
                <ChevronRight className="h-4 w-4 ml-1" />
              </Button>
            </div>
          </div>
        ))
      ) : (
        <div className="flex items-center justify-center h-full py-5">
          <p className="text-gray-500">
            Nenhum tipo de exame <span className="lowercase font-bold">{formatted_exam_library_profile_types[type as keyof typeof formatted_exam_library_profile_types]}</span> encontrado
          </p>
        </div>
      )}
    </div>
  )
}
